import Buttons from './buttons';
import RedirectToDesktopPage from './redirect-to-desktop-page';

export default { Buttons, RedirectToDesktopPage };
